import { ChartConfig } from '@/components/ui/chart'
import { ColumnDef, SortingState } from '@tanstack/react-table'
import { EquippedItem } from 'app/frontend/types/custom'
import { ActivityTimelineItem } from 'app/frontend/types/custom/ActivityTimelineItem'
import { SparkItem } from 'app/frontend/types/custom/AuditData'
import { ItemEquipmentSlot } from 'app/frontend/types/custom/ItemSlot'
import { ReactNode } from 'react'

export const toAuditRowData = (
  lastRefresh?: Record<string, string | number | undefined>,
): Record<string, string | undefined> | undefined => {
  if (!lastRefresh) return undefined
  return Object.fromEntries(
    Object.entries(lastRefresh).map(([key, value]) => [
      key,
      value == null ? undefined : String(value),
    ]),
  )
}

export type EnrichedTeamMembership = wowaudit.TeamMembership & {
  data?: Record<string, string | undefined>
  gear?: Record<ItemEquipmentSlot, EquippedItem>
  keystones?: Record<number, Record<number, { dungeon: number; level: number }>>
  mythicRatingColor?: wowaudit.CharacterDetails['mythicRatingColor']
  sparkGear?: Record<string, Record<string, SparkItem>>
  timeline?: ActivityTimelineItem[]
  uncappedCrests?: Record<string, Record<string, Record<string, number>>>
}

export type ColumnDefWithFilters<TData = EnrichedTeamMembership> = {
  columns: ColumnDef<TData>[]
  data?: TData[]
  filters?: ReactNode[]
  hasHistory?: boolean
  graphData?: {
    config: ChartConfig
    values: { label: string; total: number }[]
  }
  initialSortBy?: SortingState
  showDefaultMemberColumn?: boolean
  showPendingDataMessage?: boolean
  emptyMessage?: ReactNode
  loading?: boolean
}

export type ColumnGroup = {
  id: string
  header: string | (() => ReactNode)
  meta?: {
    className?: string
  }
  subColumns: {
    id: string
    header: string | (() => ReactNode)
    tooltip?: ReactNode
    field?: string
    accessor?: (member: EnrichedTeamMembership) => string | number
    numeric?: boolean
    size?: number
    meta?: {
      className?: string
    }
    cellWrapper?: (
      value: string | number,
      member: EnrichedTeamMembership,
    ) => ReactNode
  }[]
  rankMode?: 'max' | 'sum' | 'sequential'
  rankFields?: string[] | null
  rankWeights?: Record<string, number>
  rankInverted?: boolean
  rankById?: Record<string, number>
}
